import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_byvu4wr4: FaireBrandEntity = {
  token: "b_byvu4wr4",
  type: "brand",
  name: "Brenda Grands Waterproof Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/d7671dd1db55d57784df42409b6809292ef3d43ed471bd331d625a816d6b8b50.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dc311d36f2bd8dcc6685920b48d0fd142dab0744eb137eb0d84f58a89e24248b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d7671dd1db55d57784df42409b6809292ef3d43ed471bd331d625a816d6b8b50.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dc311d36f2bd8dcc6685920b48d0fd142dab0744eb137eb0d84f58a89e24248b.png",
  location: "Houston, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 200,
  isTopShop: true,
  isInsider: true,
  description:
    "We have a feeling you are into jewelry... which means we'll get along just fine!! ❤️\n\nBG started with two sisters and a business idea in 2014. Brenda is passionate about design and creativity while Angie heads social media marketing and loves to expand our brand through our amazing wholesalers. BG Jewelry is made for women to feel beautiful, brave, strong, worthy & loved. That is our philosophy; to create unique designs that are equally gorgeous with a pair of jeans as they are with a little black dress and heels. \n\nJewelry is our passion, and we believe in creating jewelry that honors women. As an eccentric designer, Brenda always knew that she wanted the brand to be more than just an accent piece, but a constant reminder that you are worth more than gold. We pray that every BG piece brings light to the person who wears it. Each order is carefully packaged, including a bible verse to remind you of your identity. That is the heart and soul of our brand: to remind you of your worth. \n\nAt BG we also value philanthropy, so we donate 10% of our profits to missions that align with our message such as Stay Here, our current nonprofit partner, and that makes our brand diverse in its own way. All of our products are plated or filled in 18K to 24k gold, the highest quality material just for you. All designed in Houston, TX. \n\nXX, Angie & Brenda",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:09.177Z",
    importedBy: "entity-db-cli",
  },
};
